/**
 * El arbol de una seccion esencial distinta de Cubierta (Paredes, Piso, Agua y gas, Electricidad), leido del JSON de
 * Atenea (arbolesMaderinco.js) -- el mismo archivo que leera el asistente (MADERINCO-ARBOLES-SECCIONES-T1, parte 2).
 *
 *   tipo        -> opciones con sus ids de catalogo (puede elegirse mas de una: zonas o servicios; "todavia no se")
 *   obligada    -> puntos de alcance: confirmado / pendiente / no_aplica (con motivo)
 *   complementos-> "Ver partidas de la seccion" / "Sin complementos"
 *
 * Estado (contrato de Atenea): resuelta = todos los puntos obligados confirmados o no_aplica con motivo; algun punto
 * pendiente = por_revisar (no cuenta como resuelta); algo respondido sin cerrar = en_curso; nada = pendiente.
 * Nada se agrega solo: las partidas se proponen y el usuario pone la cantidad.
 *
 * @module application/presupuestos/arbolEsencial
 */
import { ARBOLES } from './arbolesMaderinco.js';

/** El arbol de una esencial por su id, con sus tres preguntas ya separadas. null si no hay. */
export function arbolDe(id, arboles = ARBOLES) {
  const s = (arboles.sections || []).find((x) => x.id === id);
  if (!s) return null;
  const q = (qid) => (s.questions || []).find((x) => x.id === qid) || null;
  return { id: s.id, nombre: s.label, tipo: q('tipo'), obligada: q('obligada'), complementos: q('complementos') };
}

/**
 * Las partidas de la plantilla que corresponden a los tipos elegidos (por id de catalogo), con su seccion.
 * @returns {Array<{seccion:object, item:object}>}
 */
export function candidatosDeTipos(plantilla, arbol, tiposElegidos) {
  const ids = new Set();
  for (const o of arbol?.tipo?.options || []) if (tiposElegidos.has(o.id)) for (const f of o.source_ids || []) ids.add(f);
  const out = [];
  for (const s of plantilla?.secciones || []) for (const it of s.items || []) if (ids.has(it.fuenteId)) out.push({ seccion: s, item: it });
  return out;
}

/**
 * @param {object} arbol el de arbolDe
 * @param {{tipos?: Set<string>, checks?: Object<string,{estado:string, motivo?:string}>, complementos?: string}} r
 */
export function estadoDelArbol(arbol, r = {}) {
  const checks = arbol?.obligada?.checks || [];
  const resp = r.checks || {};
  const valido = (c) => { const a = resp[c.id]; return a && (a.estado === 'confirmado' || (a.estado === 'no_aplica' && String(a.motivo || '').trim())); };
  if (checks.length && checks.some((c) => resp[c.id]?.estado === 'pendiente')) return 'por_revisar';
  if (checks.length && checks.every(valido)) return 'resuelta';
  const algo = (r.tipos && r.tipos.size) || Object.keys(resp).length || r.complementos;
  return algo ? 'en_curso' : 'pendiente';
}
